/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';

export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];
    const project: ProjectConfiguration = feature.project;
    const NAME = feature.getSettingValue('NAME');
    const PROTOCOL = feature.getSettingValue('PROTOCOL');
    const LISTENPORTS = feature.getSettingValue('LISTENPORTS');
    const INTERFACES = feature.getSettingValue('INTERFACES');
    const SERVERIP = feature.getSettingValue('SERVERIP');
    const SERVERPORT = feature.getSettingValue('SERVERPORT');

    if (feature.getSettingValue('ROLE').toString() === 'client') {
        blocks.push({
            location: 'VARIABLE_DECLARATIONS',
            blockType: BlockType.CODE,
            template: `
int ${NAME}_SOCK_NUM = -1;
struct k_thread ${NAME}_sock_thread_data;
K_THREAD_STACK_DEFINE(${NAME}_sock_stack_area, 1024);

void ${NAME}_socket_thread(void*, void*, void*);

k_tid_t ${NAME}_sock_tid = k_thread_create(&${NAME}_sock_thread_data, ${NAME}_sock_stack_area,
                                 K_THREAD_STACK_SIZEOF(${NAME}_sock_stack_area),
                                 ${NAME}_socket_thread,
                                 NULL, NULL, NULL,
                                 K_LOWEST_APPLICATION_THREAD_PRIO, 0, K_NO_WAIT);

    `,
        });

        blocks.push({
            location: 'FUNCTION_DEFINITIONS',
            blockType: BlockType.CODE,
            template: `
void ${NAME}_socket_thread(void*, void*, void*) {
    LOG_INF("%s","${NAME} socket thread start");
    while (1) {
        if (${NAME}_SOCK_NUM < 0) {
            k_sleep(K_MSEC(1000));
        } else {
            char buffer[256];
            int bytes_received = recv(${NAME}_SOCK_NUM, buffer, sizeof(buffer), 0);
            // LOG_INF("bytes_received: %d", bytes_received);
            buffer[bytes_received] = '\\0';
            if (bytes_received > 0) {
                /****${NAME}_sock_data_arrival****/
                // LOG_INF("Received data: %s", buffer);
                // send(${NAME}_SOCK_NUM, buffer, bytes_received, 0);
            }
            k_sleep(K_MSEC(1000));
        }
    }
}`,
        });
    }
    return blocks;
};
